// @ts-check
import LoadBetslipRequestService from '@bto-services/api/shared/reservation-code/load-betslip.request';
import { openModal } from '@bto-services/modal';
import { BETSLIP_SEARCH_TYPE } from 'bto-models/betslip/const';
import { rebet } from '..';

/**
 * @typedef {import('bto-models/betslip/interfaces').BETSLIP_SEARCH_TYPE_ENUMS} BETSLIP_SEARCH_TYPE_ENUMS
 */

/**
 * Search for betslip code
 * @param {string} code - code to chech
 */
export async function searchBetslip(code) {
  switch (code.length) {
    case 5:
      return getBookedBetslip(code);
    case 10:
    case 20:
      return { type: BETSLIP_SEARCH_TYPE.BET_CHECK, data: code };
  }
  throw new Error('Invalid code');
}

/**
 * Get booked betslip from SB REST api
 * @param {string} code - booking code to fetch
 * @returns {Promise<{type: BETSLIP_SEARCH_TYPE_ENUMS,data: import('bto-models/betslip/interfaces').BetslipStore}>}
 */
function getBookedBetslip(code) {
  const loadBetslipRequestService = new LoadBetslipRequestService();
  loadBetslipRequestService.postParams.ReservationCode = code;
  return new Promise((res, rej) => {
    loadBetslipRequestService.execute((resp) => {
      if (!resp.data) {
        rej();
        return;
      }
      res({ type: BETSLIP_SEARCH_TYPE.BOOK, data: resp.data });
    }, () => { rej(); });
  });
}

/**
 * Load from URL booking code
 * @param {string} code - code to check
 * @param {number} items - counted items in betslip
 */
export async function loadBookCodeFromURL(code, items) {
  try {
    const res = await getBookedBetslip(code);
    // @ts-ignore
    const parsedBetslip = JSON.parse(res.data);

    if (items) {
      openModal({
        title: "Mobile.BookBetSlip",
        message: "M.RebetDescription",
        footerCb: () => {
          rebet(parsedBetslip, code);
        },
        footerBtnLabel: "M.Overwrite",
      });
      return;
    }
    rebet(parsedBetslip, code);
  } catch (error) {
    openModal({
      title: "BetSlip.Find",
      message: "Mobile.invalidcode",
    });
  }
}